import React, { useEffect, useState } from "react";
import { getPageWithSlugAPI } from "../../../Store/Action/page";
import Section1 from "../WelcomeScreen/PartnersScreen/Section1";
import Section2 from "../WelcomeScreen/PartnersScreen/Section2";
import Section3 from "../WelcomeScreen/PartnersScreen/Section3";
import Section4 from "../WelcomeScreen/PartnersScreen/Section4";
import HeaderBlack from "../WelcomeScreen/Common/Header";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pageSlug } from "../../../Constants/AppConstants";
import Footer from "../Layout/Footer/Footer";

const PartnersComunity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [partnersData, setPartnersData] = useState([]);
  const [benifitsMember, setBenefitsMember] = useState([]);

  const onBecomeManufacture = () => {
    navigate("/inquiry-form");
  };
  const onBecomeRetailer = () => {
    navigate("/login");
  };
  useEffect(() => {
    dispatch(
      getPageWithSlugAPI(pageSlug.partners, (result) => {
        setPartnersData(result?.[0]?.page_json?.[0]?.page_partner_data);
        setBenefitsMember(result?.[0]?.page_json?.[0]?.page_partner_benefits);
      })
    );
  }, [dispatch]);
  return (
    <>
      <div className="partners-screen-main-div">
        <div style={{ position: "sticky", top: 0 }}>
          <div className="section-1-div">
            <HeaderBlack noLoginBtn={true} />
          </div>
        </div>
        <Section1
          onRetailerClick={onBecomeRetailer}
          onManufactureClick={onBecomeManufacture}
        />

        <Section2 partnersData={partnersData} />
        <Section3 benifitsMember={benifitsMember} />
        <Section4 />
        <Footer />
      </div>
    </>
  );
};

export default PartnersComunity;
